import styled from 'styled-components';
import { spacing } from '../../style/theme';
var Section = styled.div.withConfig({
  displayName: "Section",
  componentId: "sc-9eajnt-0"
})(["display:flex;@media only screen and (max-width:", "px){flex-wrap:wrap;}"], spacing.collapseMenuWidth);
export default Section;